// extracted by mini-css-extract-plugin
export default {"slickArrow":"Carousel_slickArrow__ssKDR","disabled":"Carousel_disabled__mKxVa","slickNext":"Carousel_slickNext__MT0AB","slickPrev":"Carousel_slickPrev__RPZ02"};